import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { API_ENDPOINTS } from '../../../constants/api';
import { worldCupQueryKeys } from '../constants/worldcupQueryKeys';
import { GC_TIME_WORLD_CUP_MS } from '../constants/worldcupReactQuery.constants';
import type { WorldCupFuturesStats } from '../helpers/worldcupPicksData.helper';

const STALE_TIME_FUTURES_STATS_MS = 60 * 1000; // matches server cache TTL

export function useWorldCupFuturesStats(
  competitionId: string,
  enabled: boolean,
): WorldCupFuturesStats | null {
  const apiClient = useApiClient();

  const query = useQuery<WorldCupFuturesStats>({
    queryKey: worldCupQueryKeys.futuresStats(competitionId),
    queryFn: async () => {
      const res = await apiClient(API_ENDPOINTS.competitions.futuresStatsPath(competitionId));
      return (res.data as { data: WorldCupFuturesStats }).data;
    },
    enabled,
    staleTime: STALE_TIME_FUTURES_STATS_MS,
    gcTime: GC_TIME_WORLD_CUP_MS,
    refetchOnWindowFocus: false,
  });

  return query.data ?? null;
}
